<template>
    <div class="c-o-company-section  c-o-company-section--contact" id="contact">
        <div class="c-o-company-section__inner c-o-company-section__inner--centered" :class="{'c-o-company-section__inner--no-padding-bottom' : showMap}">
            <div class="c-o-company-section__main">
                <h2 class="c-o-company-section__title h2">Kontakt</h2>
                <ul class="c-o-company-section__details">
                    <li v-if="address || city" class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title"><icon :icon="'map'"></icon>Adress</span>
                        {{address}}
                        <br/>
                        {{city}}
                    </li>
                    <li v-if="phone" class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title"><icon :icon="'phone'"></icon>Telefon</span>
                        <a :href="`tel:${phone}`">{{ phone }}</a>
                    </li>
                    <li v-if="email" class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title"><icon :icon="'mail'"></icon>E-post</span>
                        <a :href="`mailto:${email}`">{{ email }}</a>
                    </li>
                    <li v-if="website" class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title"><icon :icon="'home'"></icon>Webbplats</span>
                        <a :href="website" target="_blank">{{ website }}</a>
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="showMap" class="c-o-company-section__inner c-o-company-section__inner--no-padding-top">
            <div
                v-if="longitude && latitude"
                class="c-o-company-section__map">
                <iframe
                    width="600"
                    height="320"
                    frameborder="0"
                    style="border:0"
                    :src="`https://www.google.com/maps/embed/v1/place?&q=${latitude},${longitude}&zoom=10&key=${apiKey}`"
                    allowfullscreen>
                </iframe>
            </div>
            <div
                v-else-if="address && city"
                class="c-o-company-section__map">
                <iframe
                    width="600"
                    height="320"
                    frameborder="0"
                    style="border:0"
                    :src="`https://www.google.com/maps/embed/v1/place?&q=${address},${city}&zoom=10&key=${apiKey}`"
                    allowfullscreen>
                </iframe>
            </div>
        </div>
    </div>
</template>

<script>
    import config from '../../../../config';
    import Icon from '../../atoms/AtomIcon.vue'

    import filters from '../../../../filters/index.js';

    export default {
        props: [
            'contactInfo'
        ],
        filter: filters,
        components: {
            Icon,
        },
        computed: {
            address: function() {
                return this.contactInfo.visitAddress
            },
            city: function() {
				//Matches postalcode
				var regex = /^\d{3} \d{2}/g;
				if(this.contactInfo.visitCity.match(regex)) {
					this.contactInfo.visitCity = this.contactInfo.visitCity.replace(' ', '')
				}
                return this.contactInfo.visitCity
            },
            phone: function() {
                return this.contactInfo.phone
            },
            email: function() {
                return this.contactInfo.email
            },
            website: function() {
                const link = this.contactInfo.url ? filters.addProtocol(this.contactInfo.url) : '';
                return link
            },
            latitude: function() {
                return this.contactInfo.latitude
            },
            longitude: function() {
                return this.contactInfo.longitude
            },
            apiKey: function() {
                return config.googleMapsApiKey
            },
            showMap: function() {
                return ( (this.latitude && this.longitude) || (this.address && this.city) ) && this.apiKey ? true : false
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/company-sections/OrganismCompanySectionContact.vue